import * as React from "react";
const SvgCheck = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13.333 4 6 11.333 2.667 8" /></svg>;
export default SvgCheck;